// ONE skin, «Ossidiana» — Alessio's pick of 15/10/2026 («pannello / ossidiana»): black with a single green
// light, whatever Telegram's own theme is. The s104 branch followed Telegram's colorScheme; that was my call,
// not his, and it is gone with the light palette (s105). The palette lives in index.html (:root) and no
// attribute on <html> switches it, so here we only tint Telegram's OWN chrome (header + background bars) to
// the page's black, so the seam doesn't show.
// ⚠️ Never key a style on `data-theme`: that attribute belongs to whoever HOSTS the page — the s104 preview
// viewer rewrote it, and a background keyed on it went light under dark parts (8fab33b; theme.test.ts).

// MUST mirror --bg in index.html (hand-kept in sync; theme.test.ts makes a drift loud). It tints Telegram's
// bars AROUND the page only — the page itself renders from the CSS variables, not from this.
export const THEME_BG = '#000000'

// Both methods optional — older Telegram clients lack them, in which case tinting is a silent no-op.
interface ThemeChrome {
  setHeaderColor?: (color: string) => void
  setBackgroundColor?: (color: string) => void
}

export function applyTheme(chrome?: ThemeChrome): void {
  chrome?.setBackgroundColor?.(THEME_BG)
  chrome?.setHeaderColor?.(THEME_BG)
}
